define([
       "dojo/_base/declare",
       "csi/heading/String"
], function(declare,StringRen) {

	return declare(StringRen, {
		canLink: function() {
			// [YG] DE22626: Plan-Plan- Secondary set- Target: ''Target|MerchSecondaryVersion: d is undefined' error message is displayed
			// The Navigation for MerchSecondaryPlan Views will be disabled.
			return false;
		}
	});
});